import Marquee from "react-fast-marquee";

export default function PartnersSection({ partners }) {
  if (!partners || partners.length === 0) return null;

  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="py-20 md:py-32 px-6 md:px-12 max-w-7xl mx-auto"
    >
      {/* Section Header */}
      <div className="text-center mb-16">
        <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#A07570]">
          Trusted Partners
        </span>
        <h2
          data-testid="partners-heading"
          className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-[#040404] mt-3"
        >
          Companies we have worked with
        </h2>
        <p className="text-base md:text-lg font-medium text-[#585857] leading-relaxed mt-4 max-w-xl mx-auto">
          Partnering with India's leading textile manufacturers and industrial
          groups for over two decades.
        </p>
      </div>

      {/* Logo Marquee */}
      <div className="border-b border-[#BEBEBD]/50 py-12 pb-24">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {partners.concat(partners).map((partner, i) => (
            <div
              key={`${partner.id}-${i}`}
              data-testid={`partner-logo-${partner.id}-${i}`}
              className="mx-4 flex items-center justify-center"
            >
              {partner.logo ? (
                <div className="h-40 w-80 flex items-center justify-center">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-h-36 max-w-full w-auto object-contain"
                  />
                </div>
              ) : (
                <div className="bg-[#040404]/5 px-8 py-4 rounded-lg min-w-[180px] text-center h-20 flex items-center justify-center">
                  <span className="font-heading font-bold text-lg text-[#040404]/50 tracking-tight">
                    {partner.name}
                  </span>
                </div>
              )}
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
